module.exports = __webpack_public_path__ + "images/interview-Dell_Technologies-2.svg";